import Pusher from '../pusher';

/* @ngInject */
class OnlineUsers {
	constructor(PusherService, toastr) {
		this.PusherService = PusherService;
		this.toastr        = toastr;
		this.callback      = (channelName, event, data) => {
			this.processEvent(channelName, event, data);
		};

		this.members = {};

		this.callbacks = {
			onUpdate: [],
		};
	}

	init() {
		this.on();
	}

	on() {
		this.PusherService.on(Pusher.generateChannelName('presence', 'users', null, null, 'all'), null, this.callback);
	}

	off() {
		this.PusherService.off(Pusher.generateChannelName('presence', 'users', null, null, 'all'), null, this.callback);
	}

	processEvent(channelName, event, data) {
		switch (event) {
			case 'pusher:subscription_succeeded': {
				this.members = data.members;

				this.fireOnUpdateCallbacks();

				break;
			}

			case 'pusher:member_removed': {
				const id = data.id;

				if (this.members.hasOwnProperty(id)) {
					delete this.members[id];
				}

				this.fireOnUpdateCallbacks();

				break;
			}

			case 'pusher:member_added': {
				const id = data.id;

				this.members[id] = data.info;

				this.fireOnUpdateCallbacks();

				break;
			}
		}
	}

	getMembers() {
		return this.members;
	}

	onUpdate(callback) {
		this.callbacks.onUpdate.push(callback);
	}

	fireOnUpdateCallbacks() {
		angular.forEach(this.callbacks.onUpdate, (callback) => {
			callback();
		});
	}
}

export default OnlineUsers;


// WEBPACK FOOTER //
// ./src/js/services/onlineUsers/index.js